import { createSelector, MemoizedSelector } from '@ngrx/store';
import { getPaceFormsState } from './pace-forms.selector';
import { NotificationIdentifier } from '@evorait/pace-core';
import { NotificationUtilities } from '../../utilities/notification-utilities';
import { LastOpenedFormState } from '../state/last-opened-form.state';
import { FormsState } from '../state/pace-forms.state';
import { FormIdentifier } from '../../types/form-identifier';

export const getLastOpenedForm = createSelector(getPaceFormsState, (state) => state.lastOpenedForm);
export const getLastOpenedFormByNotificationFactory = (props: {
    notification: NotificationIdentifier;
}): MemoizedSelector<FormsState, FormIdentifier | undefined, (x: LastOpenedFormState) => FormIdentifier | undefined> =>
    createSelector(
        getLastOpenedForm,
        (lastOpenedForm: LastOpenedFormState) => lastOpenedForm[NotificationUtilities.toString(props.notification)],
    );
